import React from "react";
import "./Projects.css";
import Proj from "./Proj";

function Projects() {
  return (
    <div>
      <h2 className="title">Highlighted Projects</h2>

      <div className="ui equal width grid">
        <div className="column"><Proj des=" A BlockChain based Web App build using solidity and React." link="https://github.com/sarang721/GoFundMe" title="GoFundMe" visit={false} image={require('./image/download.png').default}></Proj></div>
        <div className="column"><Proj des="A solidity-ethereum based decentralized voting application built using Blockchain and React" linkto="https://votechain-fab33.web.app/"   link="https://github.com/sarang721/VoteChain" visit={true} title="VoteChain" image={require('./image/vote.png').default}  ></Proj></div>
        <div className="column"><Proj des="
 An android application which provides end to end encryption while chatting." image={require('./image/secure.png').default} title="Secure Messenger App" visit={false} link="https://github.com/sarang721/Secure-Messenger-App-synced-with-Firebase-Database" ></Proj></div>
      </div>

      <div className="ui equal width grid">
        <div className="column"><Proj des="
Website which solves a problem of finding availabillity of beds , ventilators , plasma , etc medical services in various cities during covid pandemic." linkto="https://covid-19-927c2.web.app/"  visit={true}  title="Covi-Helper" link="https://github.com/sarang721/Covi-Helper" image={require('./image/covid.jfif').default}></Proj></div>
        

        
      </div>
      
    </div>
  );
}

export default Projects;
